const {parse} = require('url')

const VALID_URL_PROTOCOLS = ['http:', 'https:']

module.exports = urlIsValid

function urlIsValid(url) {
  const parsed = parse(url)

  // ensure a valid protocol is specified, (could check for 'https' here)
  if (!VALID_URL_PROTOCOLS.includes(parsed.protocol)) {
    return false
  }

  // ensure a host was parsed out of the URL; if not, it isn't complete
  if (!parsed.host) {
    return false
  }

  // ensure a `.` is included somewhere in the host; if not, it doesn't
  // include a TLD
  if (!parsed.host.includes('.')) {
    return false
  }

  return true
}
